'use client';

import jwt, { JwtPayload } from 'jsonwebtoken';
import Cookies from 'universal-cookie';
import { getEnvOrFail } from 'env/env';

const getJwtPayload = () => {
  const jwtPayloadCookieName = getEnvOrFail(
    'NEXT_PUBLIC_EDX_JWT_PAYLOAD_COOKIE_NAME',
  );
  const jwtPayloadCookieValue = new Cookies().get<string>(jwtPayloadCookieName);

  if (jwtPayloadCookieValue) {
    try {
      return jwt.decode(`${jwtPayloadCookieValue}.`) as JwtPayload;
    } catch {
      return null;
    }
  }
  return null;
};

export const isCookieValid = (expiryThreshold = 0) => {
  const jwtPayload = getJwtPayload();
  if (jwtPayload) {
    return jwtPayload.exp! > Date.now() / 1000 + expiryThreshold;
  }
  return false;
};
